<template>
  <div class="viewcontent" v-if="translations.account && translations.buttons">
    <h1>{{ translations.account.title }}</h1>

    <form class="row mx-3 mb-3" @submit.prevent="processUser()">
      <Alert type="warning" :list="errors.user"/>

      <div class="col-sm-6 col-xs-12">
        <label for="email" class="form-label w-100 my-3">
          {{ translations.account.email }}<span class="text-danger">*</span>
          <input
            type="text"
            id="email"
            name="email"
            class="form-control"
            v-model="user.email"
            disabled
            required
          />
        </label>
        <label for="full_name" class="form-label w-100 my-3">
          {{ translations.account.full_name }}<span class="text-danger">*</span>
          <input
            type="text"
            id="full_name"
            name="full_name"
            class="form-control"
            v-model="user.full_name"
            required
          />
        </label>
      </div>

      <div class="col-sm-6 col-xs-12">
        <div
          class=" switch form-check form-switch form-switch-md mt-5 w-100 my-2 text-start"
        >
          <input
            class="form-check-input"
            type="checkbox"
            id="editor"
            @click="changeCheck()"
            :checked="user.editor == 1 ? true : false"
          />
          <label class="form-check-label " for="editor">
            {{ translations.account.editor }}
          </label>
        </div>
        <label for="status" class="form-label w-100 my-3" v-if="usertype == 2"
          >{{ translations.account.style }}
          <select
            class="form-select"
            id="status"
            name="status"
            v-model="user.style"
          >
            <option
              v-for="(item, index) in styles"
              :key="index"
              :value="item.id"
            >
              {{ item.full_name }}
            </option>
          </select>
        </label>
      </div>
      <div class="col-sm-6 col-xs-12" v-if="user.type > 0">
        <label for="twitter" class="form-label w-100 my-3"
          >{{ translations.account.twitter }}
          <input
            class="form-control"
            type="text"
            id="twitter"
            v-model="user.twitter"
          />
        </label>
      </div>
      <div class="col-sm-6 col-xs-12" v-if="user.type > 0">
        <label for="facebook" class="form-label w-100 my-3"
          >{{ translations.account.facebook }}
          <input
            class="form-control"
            type="text"
            id="facebook"
            v-model="user.facebook"
          />
        </label>
      </div>

      <div class="col-12 pt-2" v-if="translations.buttons">
        <input
          class="btn btn-primary mx-2"
          type="submit"
          :value="translations.buttons.btn_save"
        />
      </div>
    </form>
    <h1>
      {{ translations.account.title_plan }}: <span>{{ defineType }} </span>
    </h1>
    <table class="table table-striped">
      <thead class="thead-dark">
        <tr>
          <th class="col">{{ translations.account.table.title_plan }}</th>
          <th class="col">{{ translations.account.table.plan_free }}</th>
          <th class="col">{{ translations.account.table.plan_premium }}</th>
          <th class="col">
            {{ translations.account.table.plan_professional }}
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <th class="col align-middle">{{ item.text }}</th>
          <td v-if="typeof item.free === 'boolean'" class="col align-middle">
            <img :src="require('@/assets/icon/' + defineText(item.free))" />
          </td>
          <td v-else-if="typeof item.free == 'object'" class="col align-bottom">
            <span class="new">{{ item.free.new }}</span>
          </td>
          <td v-else class="col align-middle">
            {{ defineText(item.free) }}
          </td>
          <td v-if="typeof item.premium === 'boolean'" class="col align-middle">
            <img :src="require('@/assets/icon/' + defineText(item.premium))" />
          </td>
          <td
            v-else-if="typeof item.premium == 'object'"
            class="col align-bottom"
          >
            <span class="old">{{ item.premium.old }}</span>
            <br />
            <span class="new offer">{{ item.premium.new }}</span>
          </td>
          <td v-else class="col align-middle">
            {{ defineText(item.premium) }}
          </td>
          <td
            v-if="typeof item.professional === 'boolean'"
            class="col align-middle"
          >
            <img
              :src="require('@/assets/icon/' + defineText(item.professional))"
            />
          </td>
          <td
            v-else-if="typeof item.professional == 'object'"
            class="col align-bottom"
          >
            <span class="new">{{ item.professional.new }}</span>
          </td>
          <td v-else class="col align-middle">
            {{ defineText(item.professional) }}
          </td>
        </tr>
        <tr>
          <th class="col"></th>
          <td
            v-for="(item, index) in userTypes"
            :key="index"
            class="col align-middle"
          >
            <button
              class="btn btn-primary "
              type="button"
              @click="processPay(item)"
              :disabled="usertype > item.type"
              v-if="usertype != item.type"
            >
              {{ translations.buttons.btn_changeplan }}
            </button>
            <button type="button" v-else class="btn btn-secondary w-100">
              {{ translations.buttons.btn_active }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import router from '../router'
  import Alert from '@/components/atoms/Alert.vue'

  export default {
    name: 'Account',
    components: {
      Alert,
    },
    data() {
      return {
        urlReturn: window.location.origin + window.location.pathname,
        currency: 'eur', //usd, eur,cny
        list: [],
        userTypes: [],
        styles: [],
      }
    },
    computed: {
      ...mapState([
        'user',
        'errors',
        'files',
        'translations',
        'pay',
        'usertype',
        'front',
        'languageSelected',
      ]),
      defineType() {
        let ls = JSON.parse(localStorage.getItem('token'))
        let result = ''
        switch (ls.type) {
          case 0:
            result = this.translations.account.table.plan_free
            break
          case 1:
            if (ls.plan_expiration) {
              result =
                this.translations.account.table.plan_premium +
                ' (' +
                this.translations.account.table.valid_until +
                ' ' +
                ls.plan_expiration +
                ')'
            } else {
              result =
                this.translations.account.table.plan_premium +
                ' (' +
                this.translations.account.table.indefinite +
                ')'
            }
            break
          case 2:
            if (ls.plan_expiration) {
              result =
                this.translations.account.table.plan_professional +
                ' (' +
                this.translations.account.table.valid_until +
                ' ' +
                ls.plan_expiration +
                ')'
            } else {
              result =
                this.translations.account.table.plan_professional +
                ' (' +
                this.translations.account.table.indefinite +
                ')'
            }
            break
        }
        return result
      },
      generateReceipt() {
        return 'https://pay.stripe.com/receipts/payment/' + this.user.receipt
      },
    },
    watch: {
      translations(newT, oldT) {
        this.addTranslations()
      },
    },
    methods: {
      ...mapActions(['getUser', 'editUser', 'changeToolSelected']),
      processPay(value) {
        switch (value.type) {
          case 1:
            let saveURL = this.pay
            let urlError = this.toHex(this.urlReturn + '/#/payerror')
            let urlSuccess = this.toHex(
              this.urlReturn + '#/paysuccess/' + value.type
            )
            location.href =
              saveURL +
              '?amount=' +
              value.amount +
              '&currency=' +
              this.currency +
              '&description=' +
              value.description +
              '&lang=' +
              this.languageSelected.toUpperCase() +
              '&successurl=' +
              urlSuccess +
              '&errorurl=' +
              urlError +
              '&email=' +
              this.user.email +
              '&platform=FestApp'
            break
          case 2:
            router.push('/contact')

            break
        }
      },
      showReceipt() {
        window.open(this.generateReceipt, '_blank')
      },

      defineText(value) {
        if (typeof value === 'boolean') {
          if (value) {
            value = 'true.svg'
          } else {
            value = 'false.svg'
          }
        }
        return value
      },
      changeEditStatus() {
        this.edit = !this.edit
      },
      changeCheck() {
        this.user.editor = this.user.editor == 0 ? 1 : 0
      },
      processUser() {
        this.editUser(this.user)
      },
      onPictureChange(e) {
        let file = e.target.files
        this.user.pictures = file
        this.user.edit_picture = true

        if (e.target.files.length !== 0) {
          this.preview = URL.createObjectURL(file[0])
        }
      },
      toHex(str) {
        let hex = ''
        try {
          hex = unescape(encodeURIComponent(str))
            .split('')
            .map(function(v) {
              return v.charCodeAt(0).toString(16)
            })
            .join('')
        } catch (e) {
          hex = str
          console.log('invalid text input: ' + str)
        }
        return hex
      },
      addTranslations() {
        if (this.translations.account) {
          this.list = [
            {
              text: this.translations.account.table.title_create,
              free: true,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_widget,
              free: true,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_images,
              free: true,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_geolocation,
              free: true,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_languages,
              free: false,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_duration,
              free: '1 ' + this.translations.date.day,
              premium: '5 ' + this.translations.date.days,
              professional: '10 ' + this.translations.date.day,
            },
            {
              text: this.translations.account.table.title_events,
              free: 1,
              premium: 3,
              professional: 10,
            },
            {
              text: this.translations.account.table.title_statistics,
              free: false,
              premium: false,
              professional: true,
            },
            {
              text: this.translations.account.table.title_notifications,
              free: false,
              premium: false,
              professional: true,
            },
            {
              text: this.translations.account.table.title_editor,
              free: false,
              premium: false,
              professional: true,
            },
            {
              text: this.translations.account.table.title_socialnetworks,
              free: true,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_budget,
              free: false,
              premium: false,
              professional: true,
            },
            {
              text: this.translations.account.table.title_accessibility,
              free: false,
              premium: true,
              professional: true,
            },
            {
              text: this.translations.account.table.title_price,
              free: { new: '0 €' },
              premium: {
                old: '99 €/' + this.translations.date.year,
                new: '29.70 €/' + this.translations.date.year,
              },
              professional: { new: this.translations.account.table.consult },
            },
          ]
          this.userTypes = [
            {
              type: 0,
              amount: 0,
              description: this.translations.account.pay.free,
            },
            {
              type: 1,
              amount: 29.7,
              description: this.translations.account.pay.premium,
            },
            {
              type: 2,
              amount: 100,
              description: this.translations.account.pay.professional,
            },
          ]
          this.styles = [
            // {
            //   full_name: this.translations.styles.memory,
            //   id: 'memoria.css',
            // },
            {
              full_name: this.translations.styles.default,
              id: 'memoria_default.css',
            },
          ]
        }
      },
    },
    created() {
      this.getUser()
      this.addTranslations()
    },
  }
</script>

<style scoped>
  .form-switch.form-switch-md {
    margin-bottom: 1rem; /* JUST FOR STYLING PURPOSE */
  }

  .form-switch.form-switch-md .form-check-input {
    height: 1.5rem;
    width: calc(2rem + 0.75rem);
    margin-right: 5px;
    border-radius: 3rem;
  }
  img {
    max-height: 150px;
  }
  .old {
    text-decoration: line-through;
  }
  .new {
    font-weight: bold;
  }
  .offer {
    color: red;
  }
  .switch {
    position: relative;
  }
  .switch .form-check-label {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: contents;
  }
  .switch .form-check-input {
    margin-top: 0;
  }
</style>
